import { routes } from '../constants';
import useRouter from './useRouter';

const mukibudeRouteRoots = [
	routes.aiTools.root,
	routes.myContents.root,
	routes.aiAssistantHistory.root,
];

const useIsMukibudeRoute = (): boolean => {
	const {
		match: {
			location: { pathname },
		},
	} = useRouter();

	return mukibudeRouteRoots.some(
		(root) => pathname === `/${root}` || pathname.startsWith(`/${root}/`)
	);
};

export default useIsMukibudeRoute;
